import { render, staticRenderFns } from "./WeeklySignListScreen.vue?vue&type=template&id=7bf59ff2&"
import script from "./WeeklySignListScreen.vue?vue&type=script&lang=ts&"
export * from "./WeeklySignListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports